import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const carouselImages = [
  '/referanslar/fitir-borek.png',
  '/referanslar/necmi-usta.png',
  '/referanslar/cafer.png',
  '/referanslar/buffalo.png',
  '/referanslar/midyefarm.png',
  '/referanslar/mezefarm.png',
  '/referanslar/cigerciayhan.png',
  '/referanslar/primesushi.png',
  '/referanslar/siscibo.png',
  '/referanslar/basakpide.png',
  '/referanslar/acitantuni.png',
  '/referanslar/pacacisemsi.png',
  '/referanslar/maydonoz.png',
  '/referanslar/valenss.png',
  '/referanslar/ceu.png',
  '/referanslar/camuzoglu.png',
  '/referanslar/maribo.png',
  '/referanslar/sampiyon.png',
  '/referanslar/adanadayim.png',
  '/referanslar/kebapciselman.png',
  '/referanslar/ipekdoner.png',
  '/referanslar/panino.png',
  '/referanslar/pizzacı.png',
  '/referanslar/cagdas.png',
  '/referanslar/mrkumpir.png',
  '/referanslar/chickenstop.png',
  '/referanslar/terrapizza.png',
  '/referanslar/subway.png',
  '/referanslar/secen.png',
];

const shuffleArray = (array: string[]) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const referanslar = [
  {
    logo: '/referanslar/fitir-borek.png',
    isim: 'Fıtır Börek',
    yorum: 'Motopack ile güvenilir kurye hizmeti alıyor, teslimatlarımızda hiç sorun yaşamıyoruz.'
  },
  {
    logo: '/referanslar/maydonoz.png',
    isim: 'Maydonoz Döner',
    yorum: 'Zamanında ve sorunsuz ulaşıyor. Profesyonel kurye hizmeti arayanlara kesinlikle tavsiye ederim.'
  },
  {
    logo: '/referanslar/terrapizza.png',
    isim: 'Terra Pizza',
    yorum: 'Teslimatlarda yaşadığımız tüm sorunlar Motopack ile son buldu. Hızlı, güvenli ve müşteri odaklı bir ekip.'
  },
  {
    logo: '/referanslar/buffalo.png',
    isim: 'Buffalo Burger',
    yorum: 'Motopack ile çalışmaya başladığımızdan beri hem biz hem müşterilerimiz çok daha memnun.'
  },
  {
    logo: '/referanslar/cafer.png',
    isim: 'Dürümcü Cafer Usta',
    yorum: 'Motopack ile çalışıyoruz. Güvenilir teslimat ve uygun fiyat politikaları mükemmel.'
  },
  {
    logo: '/referanslar/pacacisemsi.png',
    isim: 'Paçacı Şemşi',
    yorum: 'Kurye süreçleri hiç bu kadar kolay olmamıştı. Uygun fiyatları ve çözüm odaklı yaklaşımları sayesinde içimiz rahat.'
  },
];

const ScrollingCarousel: React.FC = () => {
  const [shuffledImages, setShuffledImages] = useState<string[]>([]);

  useEffect(() => {
    setShuffledImages(shuffleArray(carouselImages));
  }, []);

  const images = shuffledImages.length > 0 ? shuffledImages : carouselImages;
  const firstRowImages = [...images.slice(0, Math.ceil(images.length / 2)), ...images.slice(0, Math.ceil(images.length / 2))];
  const secondRowImages = [...images.slice(Math.ceil(images.length / 2)), ...images.slice(Math.ceil(images.length / 2))];

  const renderCarouselItem = (src: string, i: number) => (
    <div
      key={i}
      style={{
        flex: '0 0 auto',
        borderRadius: 14,
        overflow: 'hidden',
        background: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        border: '1px solid #e2e8f0',
        width: 120,
        height: 120,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
      }}
    >
      <img
        src={src}
        alt={`Referans ${i + 1}`}
        style={{
          width: '80%',
          height: '80%',
          objectFit: 'contain',
        }}
      />
    </div>
  );

  return (
    <div style={{
      width: '100%',
      overflow: 'hidden',
      background: '#fff',
      padding: '2rem 0',
      position: 'relative',
    }}>
      {/* First Row */}
      <div style={{
        display: 'flex',
        gap: '1.5rem',
        width: 'max-content',
        animation: 'scrollRight 120s linear infinite',
        paddingLeft: '1.5rem',
        marginBottom: '1rem',
      }}>
        {firstRowImages.map((src, i) => renderCarouselItem(src, i))}
      </div>

      {/* Second Row */}
      <div style={{
        display: 'flex',
        gap: '1.5rem',
        width: 'max-content',
        animation: 'scrollLeft 100s linear infinite',
        paddingLeft: '1.5rem',
      }}>
        {secondRowImages.map((src, i) => renderCarouselItem(src, i + firstRowImages.length))}
      </div>

      {/* Fade edges */}
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 80,
        background: 'linear-gradient(90deg, #fff 0%, transparent 100%)',
        pointerEvents: 'none',
        zIndex: 2,
      }} />
      <div style={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: 80,
        background: 'linear-gradient(270deg, #fff 0%, transparent 100%)',
        pointerEvents: 'none',
        zIndex: 2,
      }} />

      <style>{`
        @keyframes scrollRight {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        @keyframes scrollLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

const Referanslar: React.FC = () => {
  return (
    <div>
      {/* Page Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
        }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Referanslar
          </h1>
          <p style={{
            fontSize: '1.125rem',
            opacity: 0.9,
            lineHeight: 1.6,
          }}>
            Bize güvenen iş ortaklarımız ve başarı hikayelerimiz.
          </p>
        </div>
      </section>

      {/* Scrolling Carousel */}
      <ScrollingCarousel />

      {/* Testimonials */}
      <section style={{
        padding: '4rem 0',
        background: '#f8fafc',
      }}>
        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
        }}>
          <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.75rem',
              fontWeight: 700,
              color: '#0066CC',
              marginBottom: '0.5rem',
            }}>
              Müşterilerimiz
            </h2>
            <p style={{
              color: '#64748b',
              fontSize: '1rem',
            }}>
              Motopack ile çalışan bazı değerli markalar ve onların deneyimleri.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1.25rem',
          }}>
            {referanslar.map((ref, i) => (
              <div
                key={i}
                style={{
                  background: '#fff',
                  borderRadius: 14,
                  padding: '1.5rem',
                  border: '1px solid #e2e8f0',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginBottom: '1rem',
                }}>
                  <img
                    src={ref.logo}
                    alt={ref.isim}
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      background: '#f8fafc',
                      marginBottom: '0.5rem',
                    }}
                  />
                  <span style={{
                    fontWeight: 600,
                    color: '#1e293b',
                    fontSize: '1rem',
                  }}>
                    {ref.isim}
                  </span>
                </div>
                <p style={{
                  color: '#64748b',
                  fontSize: '0.9375rem',
                  lineHeight: 1.6,
                  fontStyle: 'italic',
                  textAlign: 'center',
                }}>
                  "{ref.yorum}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
        }}>
          <h2 style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: '#fff',
            marginBottom: '0.75rem',
          }}>
            Hemen Şimdi Başlayın
          </h2>
          <p style={{
            fontSize: '1rem',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '1.5rem',
          }}>
            Mutlu müşterilerimiz arasında siz de yerinizi alın.
          </p>
          <div style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <Link
              to="/hizmetal"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: '#fff',
                color: '#0066CC',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                textDecoration: 'none',
              }}
            >
              Teklif Alın
            </Link>
            <Link
              to="/iletisim"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: 'transparent',
                color: '#fff',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                border: '1.5px solid rgba(255,255,255,0.5)',
                textDecoration: 'none',
              }}
            >
              Bilgi Alın
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Referanslar;